import { EXPERIMENT_NAMES } from '@/modules/experiment/domain/experiment.constants';
import { QUIZ_VARIANTS } from '@/modules/tour/domain/tour';

export default {
  name: EXPERIMENT_NAMES.SOMATIC_YOGA_REVAMPED_FUNNEL,
  includedRoutes: ['/tour/somatic-yoga', '/tour/somatic-yoga/', '/quiz/plan-is-ready', '/quiz/plan-is-ready/'],
  allocateOnClient: true,
  variants: [
    {
      tour: QUIZ_VARIANTS.SOMATIC_YOGA,
      path: `/tour/${QUIZ_VARIANTS.SOMATIC_YOGA}`,
      expVariant: null,
    },
    {
      tour: QUIZ_VARIANTS.SOMATIC_YOGA_REVAMPED_FUNNEL,
      path: `/tour/${QUIZ_VARIANTS.SOMATIC_YOGA_REVAMPED_FUNNEL}`,
      expVariant: '5795-1',
    },
  ],
};
